function reloadUI() {
  location.reload()
}

export {reloadUI}
